module.exports = __webpack_public_path__ + "static/media/file-minus-alt.ffa4f972.svg";